import { filter, IterateeShorthand, map, maxBy, some, chain } from 'lodash'
import { GetterTree } from 'vuex'
import {
  DueTask,
  ModuleState,
  ProcessDetail,
  ProcessLog,
  RootState,
  RunningProcess,
  TaskLog,
  Process,
} from './types'

const getters: GetterTree<ModuleState, RootState> = {
  // loading
  loading: state => state.loading,

  // tasks
  doneTasks: state =>
    chain<ModuleState['taskLog']>(state.taskLog)
      .filter(t => t.end_time !== null)
      .value(),
  dueTasks: state =>
    chain<ModuleState['taskLog']>(state.taskLog)
      .filter(t => t.end_time === null)
      .map(t => ({ ...t, process: state.processes[t.process_instance_id] }))
      .value(),
  isDone: (state, myGetters) => (query: IterateeShorthand<TaskLog>) =>
    some(myGetters.doneTasks, query),
  isDue: (state, myGetters) => (query: IterateeShorthand<DueTask>) =>
    some(myGetters.dueTasks, query),
  latestDoneTask: (state, myGetters) => maxBy<TaskLog[]>(myGetters.doneTasks, 'end_time'),

  // timers
  pendingTimers: (state, myGetters) =>
    myGetters.processes.flatMap((p: RunningProcess) => p.pending_timers),
  //isPending: (state) => state.

  // processes
  activeProcesses: state => Object.values(state.processLog).filter(e => e.end_time === null),
  completedProcesses: state => Object.values(state.processLog).filter(e => e.end_time !== null),
  findLatestProcessBy: state => (query: IterateeShorthand<ProcessLog> & object) =>
    maxBy(filter(state.processLog, { state: 'ACTIVE', ...query }), 'start_time'),
  isActive: state => (query: IterateeShorthand<RunningProcess>) => some(state.processes, query),
  isComplete: (state, myGetters) => (query: IterateeShorthand<ProcessLog>) =>
    some(myGetters.completedProcesses, query),
  processDetails(state): ProcessDetail[] {
    return Object.entries(state.processLog).map(([id, p]) => ({
      active: state.processes[id],
      log: p,
    }))
  },
  processLog: state => state.processLog,
  processes: (state, myGetters) => {
    return map(state.processes, process => {
      return {
        ...process,
        dueTasks: filter(myGetters.dueTasks, { process_instance_id: process.id }),
      }
    })
  },
  currentTrial: state => {
    const trialsByStartTime = Object.values(state.processes)
      .filter(e => e.business_key === 'trial')
      .sort((a, b) => new Date(a.start_time).getTime() - new Date(b.start_time).getTime())
      .reverse()

    if (trialsByStartTime.length === 0) {
      return undefined
    } else {
      return trialsByStartTime[0]
    }
  },

  // timers
  myDates: state => state.myDates,

  // gateways
  enteredGateways: state => filter(state.gateways, { end_time: null }),
  gateways: state => state.gateways,
  passedGateways: state => filter(state.gateways, g => typeof g.end_time === 'string'),
}

export default getters
